import { HorizontalBar } from "react-chartjs-2";
import PropTypes from "prop-types";

import { comma } from "../../helpers/common.functions";

TornadoChart.propTypes = {
  originalLabels: PropTypes.any,
  dataset1: PropTypes.any,
  dataset2: PropTypes.any,
  dataset1Label: PropTypes.any,
  dataset2Label: PropTypes.any,
  unit: PropTypes.any,
};

function TornadoChart(props) {
  const { originalLabels, dataset1, dataset2 } = props;
  const { dataset1Label, dataset2Label } = props;
  const { unit } = props;

  // Sort the data and labels by absolute values (higher to lower)
  const sortedIndices = dataset1
    .map((value, index) => ({
      index,
      absValue: Math.abs(value),
    }))
    .sort((a, b) => b.absValue - a.absValue) // Sort by absolute values in descending order
    .map((item) => item.index);

  const sortedLabels = sortedIndices.map((index) => originalLabels[index]);
  const sortedDataset1 = sortedIndices.map((index) => dataset1[index]);
  const sortedDataset2 = sortedIndices.map((index) => dataset2[index]);

  const data = {
    labels: sortedLabels,
    datasets: [
      {
        label: dataset1Label,
        backgroundColor: "rgb(228, 97, 15)", // Orange color
        data: sortedDataset1,
        barThickness: 14,
      },
      {
        label: dataset2Label,
        backgroundColor: "rgb(101, 137, 176)", // Blue color
        data: sortedDataset2,
        barThickness: 14,
      },
    ],
  };

  const options = {
    responsive: true,
    legend: {
      position: "bottom",
    },
    plugins: {
      datalabels: {
        color: "#fff",
        font: {
          weight: "bold",
        },
        formatter: function (tick) {
          return comma(Math.abs(tick));
        },
      },
    },
    scales: {
      xAxes: [
        {
          ticks: {
            callback: function (tick) {
              return comma(Math.abs(tick));
            },
          },
        },
      ],
      yAxes: [
        {
          stacked: true, // Stack bars
        },
      ],
    },
    tooltips: {
      enabled: true,
      xPadding: 10,
      yPadding: 10,
      callbacks: {
        label: function (tooltipItem, chart) {
          console.log("tooltipItem", tooltipItem);
          return comma(Math.round(Math.abs(tooltipItem.xLabel))) + " / " + unit;
        },
      },
    },
  };

  let height = 300;
  if (sortedLabels.length > 2) {
    height = sortedLabels.length * 10;
  }

  return (
    <div>
      <HorizontalBar data={data} options={options} height={height} />
    </div>
  );
}

export default TornadoChart;
